module.exports = __webpack_public_path__ + "img/pa.c8526ff0.svg";